import { Card, Tag, Tooltip } from "antd";
import { formatExamples } from "../../Utils/formatExamples";
import './ColumnSelectionCard.css'


const ColumnSelectionCard = ({ columns }) => (
  <Card
    title={<span className="font-semibold text-3xl text-white">Column Selection</span>}
    className="bg-[#131314] shadow-sm pt-10 border border-gray-700"
  >
    <div className="max-h-[66vh] columnSelection-card overflow-y-auto pr-2 space-y-5">
      {columns.map((col) => (
        <div key={col.name} className="pb-4 border-b last:border-b-0">
          <div className="text-white font-medium text-base">
            Column: {col.name}
          </div>

          <div className="text-gray-200 mt-1">
            <span className="mr-1 text-base">→ Data type:</span>
            <Tag
              color={
                String(col.datatype || "")
                  .toLowerCase()
                  .includes("float") ||
                String(col.datatype || "")
                  .toLowerCase()
                  .includes("int")
                  ? "green"
                  : "blue"
              }
            >
              {col.datatype}
            </Tag>
          </div>

          <div className="text-gray-200 mt-1">
            <span className="mr-1 text-base">→ Example values:</span>
            <Tooltip title={formatExamples(col.sample_values)}>
              <code className="text-xs text-white rounded px-2 py-1 break-all">
                {formatExamples(col.sample_values)}
              </code>
            </Tooltip>
          </div>
        </div>
      ))}
    </div>
  </Card>
);

export default ColumnSelectionCard;